var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal', [_vm.isLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "article, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line"
    }
  }) : _vm.reportGroup ? _c('div', [_c('m-header', {
    attrs: {
      "breadCrumbs": _vm.breadCrumbList,
      "title": _vm.reportGroup.title,
      "subtitle": _vm.reportGroup.description,
      "actions": _vm.actions,
      "viewId": _vm.viewIdLocal,
      "chips": _vm.chips
    },
    on: {
      "update:viewId": function updateViewId($event) {
        _vm.viewIdLocal = $event;
      },
      "update:view-id": function updateViewId($event) {
        _vm.viewIdLocal = $event;
      },
      "actionClicked": function actionClicked(action) {
        return action.exec();
      }
    }
  }), _c('custom-views', {
    ref: "customViews",
    attrs: {
      "store": _vm.store,
      "entity": _vm.reportGroup,
      "viewId": _vm.viewIdLocal,
      "refType": _vm.BackendResourceEnum.REPORT,
      "boardBaseConfig": _vm.boardBaseConfig,
      "calendarBaseConfig": _vm.calendarBaseConfig,
      "tableBaseConfig": _vm.tableBaseConfig,
      "additionalCustomFieldConfig": _vm.reportGroup.configuration.status ? [_vm.reportGroup.configuration.status] : []
    },
    on: {
      "update:viewId": function updateViewId($event) {
        _vm.viewIdLocal = $event;
      },
      "update:view-id": function updateViewId($event) {
        _vm.viewIdLocal = $event;
      },
      "openSideCard": _vm.openSideCard,
      "goToSettings": _vm.goToSettings
    },
    scopedSlots: _vm._u([{
      key: "group.header",
      fn: function fn(_ref) {
        var groupBy = _ref.groupBy,
            group = _ref.group,
            toggle = _ref.toggle,
            isOpen = _ref.isOpen,
            items = _ref.items;
        return [_c('div', {
          staticStyle: {
            "display": "flex",
            "align-items": "center"
          },
          on: {
            "click": toggle
          }
        }, [groupBy[0].includes(_vm.BackendResourceEnum.VEHICLE) ? _c('refs-vehicle', {
          attrs: {
            "item": _vm.getVehicleById(group)
          },
          on: {
            "openDetail": _vm.goToVehicleDetail
          }
        }) : _vm.isDayTimeString(group) ? _c('span', [_vm._v(_vm._s(_vm.getDateTime(group)))]) : group ? _c('span', [_vm._v(_vm._s(group))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), isOpen ? _c('v-icon', [_vm._v("mdi-chevron-down")]) : _c('v-icon', [_vm._v("mdi-chevron-right")]), _c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(items.length) + " ")])], 1)];
      }
    }, {
      key: "item.groupId",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('refs-report-group', {
          attrs: {
            "itemAsync": _vm.getReportGroup(item.groupId),
            "small": true,
            "confirmable": false
          },
          on: {
            "openDetail": function openDetail($event) {
              return _vm.goToReportGroupDetail(item.groupId);
            }
          }
        })];
      }
    }, {
      key: "item.firstName",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('a', {
          on: {
            "click": function click($event) {
              return _vm.openSideCard(item);
            }
          }
        }, [_vm._v(" " + _vm._s(item.firstName) + " ")])];
      }
    }, {
      key: "item.lastName",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('a', {
          on: {
            "click": function click($event) {
              return _vm.openSideCard(item);
            }
          }
        }, [_vm._v(" " + _vm._s(item.lastName) + " ")])];
      }
    }, {
      key: "item.timestamps.created",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.timestamps.created)) + " ")];
      }
    }, {
      key: "item.vehicleId",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('refs-vehicle', {
          attrs: {
            "item": _vm.getVehicleById(item.vehicleId)
          },
          on: {
            "openDetail": _vm.goToVehicleDetail
          }
        })];
      }
    }])
  })], 1) : _c('latest-entries-card-empty'), _vm.selectedItem ? _c('partner-report-detail-side-card', {
    attrs: {
      "value": _vm.selectedItem
    },
    on: {
      "close": _vm.closeSideCard
    }
  }) : _vm._e(), _c('Can', {
    attrs: {
      "I": _vm.ActionEnum.CREATE,
      "a": _vm.ResourceEnum.COMPANY,
      "field": _vm.partnerId
    }
  }, [_c('report-create-dialog', {
    ref: "reportDialog",
    attrs: {
      "isDialogActive": _vm.isDialogActive,
      "hideButton": true,
      "partnerId": _vm.partnerId,
      "groupId": _vm.reportGroupId
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "created": function created(v) {
        _vm.$toast.success('👍');

        _vm.openSideCard(v);
      }
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }